import React, { useState, useEffect } from 'react';
import { useProfileCompletion } from '@/hooks/useProfileCompletion';
import { useAuth } from '@/hooks/useAuth';
import ProfileCompletionModal from './ProfileCompletionModal';

interface ProfileCompletionWrapperProps {
  children: React.ReactNode;
}

const ProfileCompletionWrapper: React.FC<ProfileCompletionWrapperProps> = ({ children }) => {
  const { user } = useAuth();
  const { isComplete, isLoading, missingFields } = useProfileCompletion();
  const [showModal, setShowModal] = useState(false);
  const [hasShownModal, setHasShownModal] = useState(false);

  useEffect(() => {
    // Só mostra o modal se:
    // 1. Usuário está logado
    // 2. Perfil não está completo
    // 3. Não mostrou o modal ainda nesta sessão
    // 4. Não está carregando
    // 5. Há campos faltando
    if (user && !isComplete && !isLoading && !hasShownModal && missingFields && missingFields.length > 0) {
      // Aguarda um pouco para não aparecer imediatamente após o login
      const timer = setTimeout(() => {
        setShowModal(true);
        setHasShownModal(true);
      }, 3000); // 3 segundos de delay

      return () => clearTimeout(timer);
    }
  }, [user, isComplete, isLoading, hasShownModal, missingFields]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Se não há usuário logado ou perfil está completo, não mostra o modal
  if (!user || isComplete || isLoading) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <ProfileCompletionModal
        isOpen={showModal}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default ProfileCompletionWrapper;